import { Compass, PhoneCall } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const QUICK_LINKS = [
  { id: "ressurser", label: "Ressurser" },
  { id: "kapitler", label: "Kapitler" },
  { id: "budsjett", label: "Budsjettverktøy" },
  { id: "gjeld", label: "Gjeldsverktøy" },
  { id: "raadgiver", label: "AI-rådgiver" },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="border-t border-border bg-surface-subtle/60 py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
              <Compass size={16} />
            </span>
            <span className="font-serif font-bold text-lg">Gjeldsveiviseren</span>
          </div>
          <p data-testid="footer-disclaimer" className="mt-4 text-xs text-muted-foreground leading-relaxed max-w-xs">
            Ikke tilknyttet NAV eller andre offentlige etater — en uavhengig opplysningsportal.
            Innholdet er veiledende og erstatter ikke offisiell rådgivning.
          </p>
        </div>

        <div data-testid="footer-nav-helpline">
          <p className="text-xs uppercase tracking-[0.2em] font-mono font-semibold text-muted-foreground">Hjelpetelefoner</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href="tel:55553333" className="inline-flex items-center gap-2 hover:text-primary transition-colors">
                <PhoneCall size={13} /> NAV Økonomirådgivning — <span className="font-mono font-semibold">55 55 33 33</span>
              </a>
            </li>
            <li>
              <a href="tel:22400040" className="inline-flex items-center gap-2 hover:text-primary transition-colors">
                <PhoneCall size={13} /> Kirkens SOS — <span className="font-mono font-semibold">22 40 00 40</span>
              </a>
            </li>
            <li>
              <a href="tel:80040166" className="inline-flex items-center gap-2 hover:text-primary transition-colors">
                <PhoneCall size={13} /> Forbrukerrådet — <span className="font-mono font-semibold">800 40 166</span>
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-mono font-semibold text-muted-foreground">Snarveier</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {QUICK_LINKS.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollToId(l.id)} className="hover:text-primary transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-border flex items-center justify-between">
        <p className="text-xs text-muted-foreground font-mono">© {new Date().getFullYear()} Gjeldsveiviseren — Laget for å hjelpe.</p>
        <div className="flex items-center gap-4">
          <a href="/personvern" data-testid="footer-privacy-link" className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors">Personvern</a>
          <a href="/partner" data-testid="footer-partner-link" className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors">NAV-partner</a>
          <a href="/admin" data-testid="footer-admin-link" className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors">Admin</a>
        </div>
      </div>
    </footer>
  );
}
